module.exports = __webpack_public_path__ + "static/media/pause.79ac9190.png";